import { getTvObject, tv } from '@costar-ui/cosmos';

var cardImageTV = getTvObject({
  base: ['flex', 'flex-row', 'items-center', 'justify-center'],
  variants: {
    radius: {
      none: ['rounded-t-none'],
      sm: ['rounded-t-sm'],
      base: ['rounded-t'],
      md: ['rounded-t-md'],
      lg: ['rounded-t-lg']
    }
  }
});
var base = tv(cardImageTV);
var cardImageStyles = {
  base: base
};

export { cardImageStyles, cardImageTV };
//# sourceMappingURL=card-image.styles.esm.js.map
